import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import renderTextInputWithFeedback from '../../../../components/ui/forms/renderTextInputWithFeedback'
import formValidators from '../../../../utils/validation/formValidators'
import selectors from '../../../../store/shared/selectors'
import notificationsUtils from '../../../../utils/notifications/notificationsUtils'
import { currentUserSuccess } from '../../../../store/shared/currentUserDuck'
import { performSignup, performCheckEmailInput } from '../signupDuck'
import WrongEmailMessage from '../../../../components/ui/forms/wrongEmailMessage'

class SignupForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    isPerformingSignupRequest: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
  }

  render() {
    const { handleSubmit, isPerformingSignupRequest } = this.props

    return (
      <div className="row">
        <div className="col-12">
          <form>
            <div className="row">
              <div className="col-6" style={{ paddingRight: 5 }}>
                <Field
                  component={renderTextInputWithFeedback}
                  name="firstName"
                  placeholder="First Name"
                />
              </div>
              <div className="col-6" style={{ paddingLeft: 5 }}>
                <Field
                  component={renderTextInputWithFeedback}
                  name="lastName"
                  placeholder="Last Name"
                />
              </div>
            </div>
            <Field
              component={renderTextInputWithFeedback}
              name="email"
              placeholder="Email"
              type="email"
            />
            <button
              onClick={handleSubmit}
              className="btn btn-block btn-success"
              disabled={isPerformingSignupRequest}
            >
              Send One-Time Sign On Link {'>>>>'}
            </button>
          </form>
        </div>
      </div>
    )
  }
}

/**
 * @const validate
 * @desc Checks whether our form is valid
 * @param values
 * @returns {{}}
 */
const validate = values => {
  const errors = {}

  errors.firstName = formValidators.isRequired(values.firstName)
  errors.lastName = formValidators.isRequired(values.lastName)
  errors.email = formValidators.isRequired(values.email)
  errors.email = formValidators.isAnEmail(values.email)

  return errors
}

const checkEmailInput = async (values, dispatch) => {
  try {
    const emailInput = values.email
    await performCheckEmailInput(emailInput)(dispatch)
  } catch (error) {
    const validationError = {
      email: <WrongEmailMessage errorMessage={error.message} />,
    }
    throw validationError
  }
}

/**
 * @const wrappedWithForm
 * @desc Gives SignupForm extra props like invalid, pristine, and handleSubmit
 */
const wrappedWithForm = reduxForm({
  form: 'signupForm',
  onSubmit: async (values, _dispatch, props) => {
    try {
      await props.performSignup(values)
      props.setAccessLinkRequested()
    } catch (error) {
      notificationsUtils.showErrorNotification(error.message)
    }
  },
  validate,
  asyncValidate: checkEmailInput,
  asyncChangeFields: ['email'],
})(SignupForm)

/**
 * @const makeMapStateToProps
 * @param state
 */
const makeMapStateToProps = () => {
  const isPerformingRequest = selectors.makeGetIsPerformingRequest()

  return state => ({
    isPerformingSignupRequest: isPerformingRequest(state, 'signup'),
  })
}

/**
 * @const mapDispatchToProps
 * @desc Binds an Action Performer to this.props
 * @param dispatch
 */
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      currentUserSuccess,
      performSignup,
    },
    dispatch,
  )

export default connect(makeMapStateToProps, mapDispatchToProps)(withRouter(wrappedWithForm))



// WEBPACK FOOTER //
// ./src/routes/unauthenticated/Signup/components/SignupForm.js